function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.034,
    viewBox: "0 0 24 24.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "package (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 9",
    transform: "translate(6.931 3.453)",
    style: {
      fill: "none",
      stroke: "#384853",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M9.862 5.687 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40493",
    d: "M22.723 17.34V8.574a2.191 2.191 0 0 0-1.1-1.9L13.957 2.3a2.191 2.191 0 0 0-2.191 0L4.1 6.679A2.191 2.191 0 0 0 3 8.574v8.766a2.191 2.191 0 0 0 1.1 1.9l7.67 4.383a2.191 2.191 0 0 0 2.191 0l7.67-4.383a2.191 2.191 0 0 0 1.092-1.9z",
    style: {
      fill: "none",
      stroke: "#384853",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-1 -.968)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40494",
    d: "m3.27 6.96 9.566 5.533L22.4 6.96",
    transform: "translate(-.974 -.493)",
    style: {
      fill: "none",
      stroke: "#384853",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 10",
    transform: "translate(11.862 11.989)",
    style: {
      fill: "none",
      stroke: "#384853",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M0 11.045V0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.8edc92284281edd3b2e4f32ab831751f.svg";
export { ForwardRef as ReactComponent };